module.exports = __webpack_public_path__ + "307a4f5a.svg";